import { useEffect, useState } from "react";
import { Row, Form } from "react-bootstrap";
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faPills } from '@fortawesome/free-solid-svg-icons';

import api from "../../services/api";

import Menu from "../../components/Menu";
import LoadingBlock from "../../components/LoadingBlock";
import AttendanceFullCard from "../../components/AttendanceFullCard";
import AttendancePartialCard from "../../components/AttendancePartialCard";

import { usePusherChannel } from "../../hooks/usePusherChannel";

export default function Sales() {
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
  const [search, setSearch] = useState("");
  const [attendances, setAttendances] = useState([]);

  const [openBudgets, setOpenBudgets] = useState(false);

  // Filtro combinado: primeiro aplica o filtro de orçamentos, depois o filtro de busca
  const filteredAttendances = attendances
    .filter(att => openBudgets ? att.send_budget !== true : true)
    .filter(att => search === "" || att.name?.toUpperCase().includes(search.toUpperCase()));

  const fetchPrescriptions = async (loading = true) => {
    setLoading(loading);

    try {
      const response = await api.post('api/attendances/pharmacy/list', {
        date_start: date,
        //customer_name: search.toUpperCase()
      });

      setAttendances(response.data);
    } catch (error) {
      console.error("Erro ao buscar atendimentos:", error);
      setAttendances([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrescriptions();

    // Limpa a busca quando a data muda
    if (search !== "") {
      setSearch("");
    }
  }, [date]);

  usePusherChannel(
    "update-pharmacy-sale-channel",
    "update-pharmacy-sale-event",
    () => {
      fetchPrescriptions(false);
    }
  );

  usePusherChannel(
    "update-pos-pharmacy-sale-channel",
    "update-pos-pharmacy-sale-event",
    () => {
      fetchPrescriptions(false);
    }
  );

  usePusherChannel(
    "update-pos-doctor-pharmacy-sale-channel",
    "update-pos-doctor-pharmacy-sale-event",
    () => {
      fetchPrescriptions(false);
    }
  );

  const infosCompleted = (attendance) => {
    const result = !!(attendance.name && attendance.mobile && attendance.professional_name &&
      attendance.date_scheduling && attendance.cpf && attendance.birth &&
      attendance.attendance_id && (attendance.scheduling_id !== null && attendance.scheduling_id !== undefined));

    return result;
  }

  const refreshAttendances = (attendanceId, newStatus) => {
    setAttendances(prevAttendances =>
      prevAttendances.map(att =>
        att.attendance_id === attendanceId
          ? { ...att, budget_status: newStatus }
          : att
      )
    );
  }

  const screenTela =
    <div className="ms-4 mt-3">
      <div className="row row-container">
        <div className="d-flex align-items-center justify-content-evenly align-items-center">
          <FontAwesomeIcon icon={faPills} size="2xl" className="me-4" style={{ color: '#00468B' }} />

          <h1 className="col-6 col-sm-6 col-lg-6 name-screen my-4"> <span className="name-screen-title" >Central de Medicamentos</span> </h1>

          <Form.Check
            type="switch"
            id="open-budgets"
            label="Orçamentos em aberto"
            className="mt-3 col-2"
            style={{ position: 'relative', right: '150px' }}
            checked={openBudgets}
            onChange={(e) => setOpenBudgets(e.target.checked)}
          />

          <input style={{ maxWidth: 165 }} value={date} onChange={(value) => {
            if (value.target.value === '') return
            setDate(value.target.value)
          }} type="date" placeholder="Pesquisar por Cliente" className="form-control input-pesquisa-non-focus me-3" />

          <input value={search} onChange={(value) => {
            setSearch(value.target.value.toUpperCase())
          }} type="text" placeholder="Pesquisar por Cliente" className="form-control input-pesquisa-vendas" />
        </div>

        <div className="pb-5" style={{ height: 'calc(100vh - 150px)', overflowY: 'auto' }}>
          {
            loading ? (
              <LoadingBlock />
            ) : (
              filteredAttendances.length > 0 ? (
                <Row xs={1} className="g-3">
                  {filteredAttendances.map((attendance) => (
                    infosCompleted(attendance) ? (
                      <AttendanceFullCard key={attendance.attendance_id} attendance={attendance} onAttendanceUpdate={refreshAttendances} />
                    ) : (
                      <AttendancePartialCard key={`impressora-${attendance.attendance_id}`} attendance={attendance} refresh={fetchPrescriptions} />
                    )
                  ))}
                </Row>
              ) : (
                <div className='no-sales row align-items-center'>
                  <h3 className='text-center title-screen'>Sem vendas na data especificada</h3>
                </div>

              )
            )
          }
        </div>
      </div>
    </div>

  return (
    <Menu screen={screenTela} />
  )
}